//
// URL.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";

var URL = createModule("commons::URL", [], ClosetObject, [
    {
        DEFAULT_PORT_HTTP_CONNECTION: 80,
        DEFAULT_PORT_HTTPS_SECURE_CONNECTION: 443,
    },
    ,
    ,
    {
        path: 7,
        hostname: 7,
        fragment: 7,
        scheme: 7,
        port: 4,
        query: 7,
    },
    {
        isValid: [2],
        getRawURLString: [7],
        getFinishedURLString: [7],
    },
    {
        _create_v: [4],
        _create_s: [4,7],
    },
    ,
    ["_create"]
]);
export default URL;
